/**
 * Cores de usuário: o único elemento colorido da interface (seção 21).
 * Paleta escolhida para contraste sobre fundo escuro e claro.
 */
export const USER_COLORS = [
  "#3B82F6", // azul
  "#F97316", // laranja
  "#10B981", // verde
  "#EC4899", // rosa
  "#A855F7", // roxo
  "#EAB308", // amarelo
  "#06B6D4", // ciano
  "#EF4444", // vermelho
  "#84CC16", // lima
  "#F59E0B", // âmbar
] as const;

/** Cor determinística por usuário: a mesma pessoa tem a mesma cor em todas as sessões. */
export function colorForUser(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) hash = (hash * 31 + userId.charCodeAt(i)) | 0;
  return USER_COLORS[Math.abs(hash) % USER_COLORS.length]!;
}

/** Versão translúcida usada para a seleção de outras pessoas no editor. */
export function lightColor(hex: string, alpha = 0.2): string {
  const a = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, "0");
  return `${hex}${a}`;
}
